import React from 'react';
import { useOutsideClick } from 'hooks/useOutsideClick';
import { createDropdownClassName } from './dropdownStyles';

type TProps = {
  opened: boolean;
  onOutsideClick(): void;
};

export const DropdownWrapper: React.FC<TProps> = ({
  children,
  opened,
  onOutsideClick,
}) => {
  const wrapperRef = useOutsideClick<HTMLDivElement>(onOutsideClick);

  const className = createDropdownClassName('wrapper', { opened });

  return (
    <div ref={wrapperRef} className={className}>
      {children}
    </div>
  );
};
